import GenericModel from '../../generic-model';
import BoardType from '../board/board-type';
import IPBoardPlacementType from './ip-board-placement-type';
import { SignDetail } from '../../sign/sign-detail';
import IPBoardPartType from './ip-board-part-type';
import { SignTitleAdjustment } from '../../sign/title/sign-title-adjustment';
import { SignPhoneNumberAdjustment } from '../../sign/phone/sign-phone-number-adjustment';
import { SignStickerDetail } from '../../sign/sticker/sign-sticker-detail';
import { IPBoardPartAbbreviation } from './ip-board-part-abbreviation';
import { IPBoardPartPhoneNumber } from './ip-board-part-phone-number';

export default class IPBoardPart extends GenericModel {
  sign?: SignDetail;

  otherIPBoardPartType?: IPBoardPartType;
  otherHeight?: number;
  otherWidth?: number;

  boardType?: BoardType;
  divergentBoardType?: string;
  placementType?: IPBoardPlacementType;
  alternativePlacementType?: string;

  customText?: string;
  otherCustomText?: string;

  titleAdjustment?: SignTitleAdjustment;
  otherTitleAdjustment?: SignTitleAdjustment;
  otherTitle?: string;
  otherSideOtherTitle?: string;

  phoneNumberAdjustment?: SignPhoneNumberAdjustment;
  otherPhoneNumberAdjustment?: SignPhoneNumberAdjustment;
  otherPhoneNumber?: string;
  otherSideOtherPhoneNumber?: string;

  sticker?: SignStickerDetail;
  otherSticker?: string;

  abbreviations?: IPBoardPartAbbreviation[];
  phoneNumbers?: IPBoardPartPhoneNumber[];

  // display variables
  signOptionSelected?: boolean;
  calculatedPlacementPrice?: number;

  // immo ip placer display variables
  kind?: string;
  placementMinuteBudget?: number;
  repoMinuteBudget?: number;

  // for remembering content of title/phone number adjustment/sticker
  previousTitleContent?: string;
  previousOtherSideTitleContent?: string;
  previousPhoneNumberContent?: string;
  previousOtherSidePhoneNumberContent?: string;
  previousStickerContent?: string;
}
